import { objectTypes } from "src/consts/objectTypes.js";
import { ListInspections } from "src/components/ListInspections.js";

export function DeviationsList() {
  return <ListInspections objectType={objectTypes.Deviation} />;
}
